import React from "react";
import { Helmet } from "react-helmet";
// Screens
import Landing from "./screens/Landing.jsx";

export default function App() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
        <meta name="theme-color" content="#17152f" />
        <meta name="description" content="Omnicom Solutions Limited delivers telecom engineering, network performance, software, cloud and power solutions across Nigeria and Africa." />
        <title>Omnicom Solutions | Telecom &amp; Technology Infrastructure</title>
      </Helmet>
      <Landing />
    </>
  );
}

